import { ConversationalChatOverlayMessageComponent } from '@klant/conversational/conversational-chat-overlay-message/conversational-chat-overlay-message.component';

import { NgModule } from '@angular/core';

import { ApContentPipe, ApContentService } from '@ap/content';
import { ApButtonComponent } from '@ap/button';
import { ApPanelComponent } from '@ap/panel';

@NgModule({
    declarations: [ConversationalChatOverlayMessageComponent],
    exports: [ConversationalChatOverlayMessageComponent],
    imports: [ApContentPipe, ApButtonComponent, ApPanelComponent],
    providers: [ApContentService]
})
export class ConversationalChatOverlayMessageModule {}
